import { InjectionToken, WritableSignal } from '@angular/core';

/**
 * Eén extra icoon-knop die {@link FloatingPanelHostComponent} bovenaan rechts
 * weergeeft, links van de dock- en sluit-knoppen. Bedoeld voor content-
 * specifieke modus-wissels (bv. compacte ↔ volledige weergave) die los van
 * het generieke close/dock-paar staan.
 *
 * Het is verantwoordelijkheid van de content-component (of zijn wrapper) om
 * de signaal-set bij te werken wanneer zijn eigen state verandert.
 */
export interface FloatingPanelHeaderAction {
  /**
   * FontAwesome-icoon naam (zonder `fa-`-prefix). Optioneel: laat weg
   * wanneer je een korte tekst-label wilt tonen i.p.v. een icoon (bv. voor
   * een A/B/C-cyclische toggle).
   */
  readonly icon?: string;
  /**
   * Optionele tekst-label die i.p.v. (of naast) het icoon getoond wordt.
   * Gebruikt voor toggles waarvan de actuele state direct zichtbaar moet
   * zijn (bv. een variant-keuze).
   */
  readonly label?: string;
  /** Tekst voor de hover-tooltip én aria-label. */
  readonly tooltip: string;
  /** Klik-handler. Stopt event-propagation niet — dat doet de host zelf. */
  readonly onClick: () => void;
}

/**
 * Per-entry writable signaal — geleverd door de {@link FloatingPanelService}
 * via de content-injector zodat zowel de inhoud (writer) als de host (reader)
 * over hetzelfde signaal beschikken zonder een extra service-laag.
 */
export const FLOATING_PANEL_HEADER_ACTIONS = new InjectionToken<
  WritableSignal<readonly FloatingPanelHeaderAction[]>
>('FLOATING_PANEL_HEADER_ACTIONS');
